import { render } from "./Clients.vue?vue&type=template&id=8651b402&scoped=true"
import script from "./Clients.vue?vue&type=script&lang=ts"
export * from "./Clients.vue?vue&type=script&lang=ts"

import "./Clients.vue?vue&type=style&index=0&id=8651b402&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8651b402"

export default script